import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from 'src/app/app.component';
import { AlertService } from 'src/app/services/alert.service';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { PaginatorComponent } from '../paginator/paginator.component';
import { AlertDTO } from 'src/app/model/alerts/alert-dto';
import { Utils } from 'src/app/utils/utils';
import { BlockIpComponent } from './block-ip/block-ip.component';
import { CyberAttackManagementTypeEnum } from 'src/app/model/alerts/attacks/cyber-attack-management-type-enum';

@Component({
  selector: 'app-block-ip-list',
  templateUrl: './block-ip-list.component.html',
  styleUrl: './block-ip-list.component.scss',
})
export class BlockIpComponentList implements AfterViewInit {
  public alerts: AlertDTO[] = [];
  public pageSize = 20;

  public utils = new Utils();

  // filters
  public managedFilter: boolean | undefined = undefined;
  public dateFromFilter: string | undefined = undefined;
  public dateToFilter: string | undefined = undefined;

  // buttons
  public allTimeButton = false;
  public thisMonthButton = false;
  public thisYearButton = false;

  @ViewChild('alertsPaginator')
  public paginator?: PaginatorComponent;

  constructor(
    private alertService: AlertService,
    private toastService: ToastrService,
    private loadIndicatorService: LoadIndicatorService,
    private dialog: MatDialog,
  ) {
    AppComponent.updateAppHeader('Block Ip');
  }

  ngAfterViewInit(): void {
    if (this.paginator) {
      this.loadAlerts();
    }
  }

  loadAlerts() {
    this.loadIndicatorService.show();
    this.alertService
      .getManualAlerts(
        this.paginator!.selectedPage,
        this.pageSize,
        this.dateFromFilter,
        this.dateToFilter,
        this.managedFilter,
      )
      .then((res) => {
        this.alerts = res.items;
        this.paginator?.updateData(res.totalPages, res.pageSize);
      })
      .catch((er) => {
        this.toastService.error(er);
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  filterManagedClicked(value: boolean | undefined) {
    this.managedFilter = value;
    this.loadAlerts();
  }

  filterAllTimeDateClicked() {
    this.resetButtons();
    this.allTimeButton = true;

    this.dateFromFilter = new Date(1999, 1, 1).toDateString();
    this.dateToFilter = new Date(2099, 1, 1).toDateString();
    this.loadAlerts();
  }

  filterThisYearDateClicked() {
    this.resetButtons();
    this.thisYearButton = true;

    let dateToday = new Date();
    dateToday.setDate(1);
    dateToday.setMonth(0);
    this.dateFromFilter = dateToday.toDateString();

    dateToday.setFullYear(dateToday.getFullYear() + 1);
    this.dateToFilter = dateToday.toDateString();
    this.loadAlerts();
  }

  filterThisMonthDateClicked() {
    this.resetButtons();
    this.thisMonthButton = true;

    let dateToday = new Date();
    dateToday.setDate(1);
    this.dateFromFilter = dateToday.toDateString();

    dateToday.setDate(0);
    dateToday.setMonth(dateToday.getMonth() + 1);
    this.dateToFilter = dateToday.toDateString();
    this.loadAlerts();
  }

  createAlert() {
    this.dialog
      .open(BlockIpComponent)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.loadAlerts();
        }
      });
  }

  onDeleteButtonClicked(alert: AlertDTO) {
    this.loadIndicatorService.show();
    this.alertService
      .unmanageAttack(alert.attacks![0], true)
      .then(() => {
        this.toastService.success('Successfully deleted');
        this.loadAlerts();
      })
      .catch((er) => {
        this.toastService.error(er);
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  onRetryButtonClicked(alert: AlertDTO) {
    this.loadIndicatorService.show();
    this.alertService
      .manageAttack(alert.attacks![0], CyberAttackManagementTypeEnum.BlockIp)
      .then(() => {
        this.toastService.success('Successfully deleted');
        this.loadAlerts();
      })
      .catch((er) => {
        this.toastService.error(er);
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  private resetButtons() {
    this.allTimeButton = false;
    this.thisMonthButton = false;
    this.thisYearButton = false;
  }
}
